// TODO: remove this file
import { setServerErrors } from '../slice/appSlice';

export const setServerError = response => {
    return {
        type: setServerErrors,
        payload: response
    }
}